"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSetRoutes = void 0;
exports.handleSetRoutes = function (state, routes) {
    var processedRoutes = {};
    var processedTitleGetters = {};
    Object.entries(routes).forEach(function (_a) {
        var route = _a[0], titleOrTitleGetter = _a[1];
        processedRoutes[route] = route;
        var titleGetter = titleOrTitleGetter instanceof Function
            ? titleOrTitleGetter
            : function () { return titleOrTitleGetter; };
        processedTitleGetters[route] = titleGetter;
        if (route === '/') {
            processedRoutes[''] = route;
            processedTitleGetters[''] = titleGetter;
        }
    });
    return __assign(__assign({}, state), { routes: processedRoutes, titleGetters: processedTitleGetters });
};
